export const priceCardData = [
  {
    title: "Basic",
    price: "Free",
    per: "",
    button: "Get Started",
    buttonColor: "border-2 border-black",
    features: [
      "1 hour meeting limit",
      "100 attendees",
      "Chat box",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing"
    ],
    link: "/"
  },
  {
    title: "Standard",
    price: "$200/",
    per: "20% off",
    button: "Upgrade",
    buttonColor: "bg-green text-white",
    features: [
      "1 hour meeting limit",
      "100 attendees",
      "Chat box",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing"
    ],
    link: "/"
  },
  {
    title: "Premium",
    price: "$500/",
    per: "20% off",
    button: "Upgrade",
    buttonColor: "border-2 border-black",
    features: [
      "1 hour meeting limit",
      "100 attendees",
      "Chat box",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing"
    ],
    link: "/"
  },
  {
    title: "Enterprise",
    price: "$750/",
    per: "20% off",
    button: "Upgrade",
    buttonColor: "bg-orange text-white",
    features: [
      "1 hour meeting limit",
      "100 attendees",
      "Chat box",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing",
      "collaboration and file sharing"
    ],
    link: "/"
  }
];
